export default __webpack_public_path__ + "static/1.2-446130e0bbe1d32e327459a89afef88d.webp";